module.exports = __webpack_public_path__ + "media/images/emblems/Conthey-8d00ff11cf44b8d08d743a5692b2a109.png";